import { Box, useTheme } from "@mui/material";
import type { LucideIcon } from "lucide-react";
import type { FC } from "react";

interface DrawerButtonProps {
  icon: LucideIcon;
  onClick: () => void;
  disabled?: boolean;
}

export const DrawerButton: FC<DrawerButtonProps> = ({
  icon: Icon,
  onClick,
  disabled = false,
}) => {
  const { colors, radius } = useTheme();

  return (
    <Box
      onClick={onClick}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: disabled ? "not-allowed" : "pointer",
        width: 40,
        height: 40,
        backgroundColor: colors.background.hover,
        borderRadius: radius.full,
        transition: "all 0.2s",
        opacity: disabled ? 0.6 : 1,
        "&:hover": {
          backgroundColor: disabled
            ? colors.background.hover
            : colors.background.selected,
        },
      }}
    >
      <Icon size={16} color={colors.text.primary} />
    </Box>
  );
};
